module.exports = __webpack_public_path__ + "img/time_boundary_event_selected.d7763ce9.svg";